"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function ChipItem(_a) {
    var dataCy = _a.dataCy, getItemLabel = _a.getItemLabel, item = _a.item, isDisabled = _a.isDisabled, onRemove = _a.onRemove;
    return (react_1.default.createElement("div", { className: "selected-item" },
        react_1.default.createElement("span", { "data-cy": "".concat(dataCy, "-selected") }, getItemLabel(item)),
        react_1.default.createElement("i", { "data-cy": "".concat(dataCy, "-remove-selected"), className: "implioicons-cross", onClick: function () { return !isDisabled && onRemove(item); } })));
}
exports.default = ChipItem;
